import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { RefreshCw, Home, AlertTriangle } from 'lucide-react';

function ServerError() {
  const navigate = useNavigate();

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 text-center">
      <div className="mb-6">
        <AlertTriangle className="w-24 h-24 text-QWA2_TALENT_SHOW-red mx-auto animate-pulse" />
      </div>
      
      <h1 className="text-7xl font-black text-QWA2_TALENT_SHOW-gold">500</h1>
      <h2 className="mt-4 text-3xl font-bold text-gray-900">
        Internal <span className="red-gold-gradient-text">Server Error</span>
      </h2>
      
      <p className="mt-4 text-gray-600 max-w-md mx-auto">
        Oops! Our server encountered an unexpected condition. Don't worry, our team has been notified. 
        Try refreshing the page or come back later.
      </p>

      <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
        <Button 
          onClick={handleRetry}
          className="bg-QWA2_TALENT_SHOW-black text-white font-bold uppercase tracking-wider py-6 px-8 rounded-2xl hover:opacity-90 transition flex items-center gap-2"
        >
          <RefreshCw className="w-5 h-5" />
          Try Again
        </Button>
        
        <Button 
          variant="outline"
          onClick={() => navigate('/')}
          className="border-2 border-QWA2_TALENT_SHOW-gold text-QWA2_TALENT_SHOW-gold font-bold uppercase tracking-wider py-6 px-8 rounded-2xl hover:bg-QWA2_TALENT_SHOW-gold hover:text-white transition flex items-center gap-2"
        >
          <Home className="w-5 h-5" />
          Go Home
        </Button>
      </div>
    </div>
  );
}

export default ServerError;